import React, { useState, useEffect } from 'react';
import { browseFolder } from '../../services/folder';
import './FolderSelector.css';

const FolderSelector = ({ isOpen, onSelect, onCancel, title = 'Selecciona carpeta de destino' }) => {
  const [currentPath, setCurrentPath] = useState('/');
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setCurrentPath('/');
      loadFolder('/');
    }
  }, [isOpen]);

  const loadFolder = async (path) => {
    setLoading(true);
    setError('');
    try {
      const data = await browseFolder(path, 0, 1000);
      const folders = data.items.filter(e => e.type === 'directory' && e.name !== 'Analisis');
      setEntries(folders);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al cargar carpetas');
    } finally {
      setLoading(false);
    }
  };

  const handleNavigate = (folderPath) => {
    setCurrentPath(folderPath);
    loadFolder(folderPath);
  };

  const handleGoUp = () => {
    const parts = currentPath.split('/').filter(Boolean);
    parts.pop();
    const newPath = '/' + parts.join('/') || '/';
    setCurrentPath(newPath);
    loadFolder(newPath);
  };

  const handleSelect = () => {
    onSelect(currentPath);
  };

  const getBreadcrumbParts = () => {
    return currentPath.split('/').filter(Boolean);
  };

  if (!isOpen) return null;

  return (
    <div className="folder-selector-overlay" onClick={onCancel}>
      <div className="folder-selector-modal" onClick={(e) => e.stopPropagation()}>
        <div className="folder-selector-header">
          <h3>{title}</h3>
          <button className="btn-close" onClick={onCancel}>&times;</button>
        </div>

        <div className="folder-selector-breadcrumb">
          <button onClick={() => handleNavigate('/')} className="breadcrumb-item">
            Raiz
          </button>
          {getBreadcrumbParts().map((part, idx, arr) => (
            <React.Fragment key={idx}>
              <span className="breadcrumb-separator">/</span>
              <button
                onClick={() => handleNavigate('/' + arr.slice(0, idx + 1).join('/'))}
                className="breadcrumb-item"
              >
                {part}
              </button>
            </React.Fragment>
          ))}
        </div>

        {error && <div className="folder-selector-error">{error}</div>}

        <div className="folder-selector-content">
          {currentPath !== '/' && (
            <div className="folder-item folder-up" onClick={handleGoUp}>
              <span className="folder-icon">⬆️</span>
              <span className="folder-name">..</span>
            </div>
          )}

          {loading ? (
            <div className="folder-selector-loading">Cargando...</div>
          ) : entries.length === 0 ? (
            <div className="folder-selector-empty">No hay subcarpetas</div>
          ) : (
            entries.map((entry, idx) => (
              <div
                key={idx}
                className="folder-item"
                onClick={() => handleNavigate(entry.path)}
              >
                <span className="folder-icon">📁</span>
                <span className="folder-name">{entry.name}</span>
              </div>
            ))
          )}
        </div>

        <div className="folder-selector-footer">
          <div className="selected-path">
            <span className="path-label">Destino:</span>
            <span className="path-value">{currentPath}</span>
          </div>
          <div className="folder-selector-actions">
            <button className="btn-cancel" onClick={onCancel}>
              Cancelar
            </button>
            <button className="btn-select" onClick={handleSelect}>
              Seleccionar esta carpeta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FolderSelector;
